
(($) => {

    $(document).on('click', '[data-toggle="scroll"]', (e) => {
        e.preventDefault();

        const button = $(e.target).closest('[data-toggle="scroll"]');
        const scrollTo = $(`${button.data('target')}`);

        if (scrollTo.length > 0) {
            $('html, body').stop().animate({ scrollTop: scrollTo.offset().top }, 400);
        }
    });
})(jQuery);
